import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom email validator that ensures email addresses contain both '@' and '.'
 * Pattern: \b[\w\.-]+@[\w\.-]+\.\w{2,4}\b
 * 
 * This validator checks for:
 * - Presence of '@' symbol
 * - Presence of '.' after the '@' symbol
 * - Valid domain extension (2-4 characters)
 */
export function emailValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const valid = /^[\w\.-]+@[\w\.-]+\.\w{2,4}$/.test(control.value);
  return valid ? null : { invalidEmail: true };
}
